export const LEGAL_TERMS_OF_USE_HEADING: string = `

<center>
 <h1 style="margin-bottom: 0">Nutzungsbedingungen</h1>
 Übersicht über die Allgemeinen Geschäftsbedingungen
</center>

---

## Nutzungsbedingungen

*Gültig ab dem 19. November 2024*
`;
